export function getB2BBookingStatus() {
  return {
    types: [
      `GET_B2B_BOOKING_STATUS_PENDING`,
      `GET_B2B_BOOKING_STATUS_FULFILLED`,
      `GET_B2B_BOOKING_STATUS_REJECTED`,
    ],
    url: `v1/corporate-booking/booking-status`,
  };
}
export function getEnquiryBookingStatus() {
  return {
    types: [
      `GET_ENQUIRY_BOOKING_STATUS_PENDING`,
      `GET_ENQUIRY_BOOKING_STATUS_FULFILLED`,
      `GET_ENQUIRY_BOOKING_STATUS_REJECTED`,
    ],
    url: `v1/corporate-booking/third-party/status`,
  };
}
export function getBookingStatus() {
  return {
    types: [
      `GET_B2B_BOOKING_STATUS_PENDING`,
      `GET_B2B_BOOKING_STATUS_FULFILLED`,
      `GET_B2B_BOOKING_STATUS_REJECTED`,
    ],
    url: `v1/corporate-booking/booking-status`,
  };
}

export function getTripDetails(id) {
  return {
    types: [
      `GET_TRIP_DETAILS_PENDING`,
      `GET_TRIP_DETAILS_FULFILLED`,
      `GET_TRIP_DETAILS_REJECTED`,
    ],
    method: "GET",
    url: `v1/corporate-booking/bookings/${id}`,
  };
}

export function getTripFares(id) {
  return {
    types: [
      `GET_FARE_DETAILS_PENDING`,
      `GET_FARE_DETAILS_FULFILLED`,
      `GET_FARE_DETAILS_REJECTED`,
    ],
    method: "GET",
    url: `v1/corporate-booking/bookings/fare-detail/${id}`,
  };
}

export function operatorAssign(data) {
  console.log({ dwhqudwio: data });
  let method = "PATCH";
  let url = `v3/bookings/operator/assign/${data.id}`;
  delete data.id;
  return {
    types: [
      `UPDATE_OPERATOR_ASSIGN_PENDING`,
      `UPDATE_OPERATOR_ASSIGN_FULFILLED`,
      `UPDATE_OPERATOR_ASSIGN_REJECTED`,
    ],
    method,
    url,
    data,
    payload: { receiveType: "postData" },
  };
}
export function updateTripDetails(data) {
  let method = "PATCH";
  let url = `v1/corporate-booking/update-booking/${data.id}`;
  delete data.id;
  return {
    types: [
      `UPDATE_TRIP_DETAILS_PENDING`,
      `UPDATE_TRIP_DETAILS_FULFILLED`,
      `UPDATE_TRIP_DETAILS_REJECTED`,
    ],
    method,
    url,
    data,
    payload: { receiveType: "postData" },
  };
}

// export function aggregatorDriverAssign(data, vehicleId, vehicleMake) {
//   let method = "PATCH";
//   console.log({ zxcv: vehicleMake });
//   let url = data.vehicleId
//     ? `v1/corporate-booking/operator/driver/reassign/${data.id}/${data.driverId}/${data.vehicleId}`
//     : `v1/corporate-booking/operator/driver/assign/${data.id}/${data.driverId}/${data.vehicleId}`;
//   delete data.id;
//   return {
//     types: [
//       `AGGREGATOR_DRIVER_ASSIGN_PENDING`,
//       `AGGREGATOR_DRIVER_ASSIGN_FULFILLED`,
//       `AGGREGATOR_DRIVER_ASSIGN_REJECTED`,
//     ],
//     method,
//     url,
//   };
// }

// export function aggregatorDriverAssign(data, vehicleId, vehicleMake) {
//   let method = "PATCH";
//   let url = `v3/bookings/driver/assign/${data.id}/${data.driverId}/${data.vehicleId}`;
//   delete data.id;
//   return {
//     types: [
//       `AGGREGATOR_DRIVER_ASSIGN_PENDING`,
//       `AGGREGATOR_DRIVER_ASSIGN_FULFILLED`,
//       `AGGREGATOR_DRIVER_ASSIGN_REJECTED`,
//     ],
//     method,
//     url,
//   };
// }

export function aggregatorDriverAssign(data, vehicleId, vehicleMake) {
  let method = "PATCH";
  let url = `v3/bookings/driver/assign/${data.id}`;
  delete data.id;
  return {
    types: [
      `AGGREGATOR_DRIVER_ASSIGN_PENDING`,
      `AGGREGATOR_DRIVER_ASSIGN_FULFILLED`,
      `AGGREGATOR_DRIVER_ASSIGN_REJECTED`,
    ],
    method,
    url,
    data,
    payload: { receiveType: "postData" },
  };
}

export function aggregatorDriverReassign(data, vehicleId, vehicleMake) {
  let method = "PATCH";
  let url = `v3/bookings/driver/reassign/${data.id}`;
  delete data.id;
  return {
    types: [
      `AGGREGATOR_DRIVER_ASSIGN_PENDING`,
      `AGGREGATOR_DRIVER_ASSIGN_FULFILLED`,
      `AGGREGATOR_DRIVER_ASSIGN_REJECTED`,
    ],
    method,
    url,
    data,
    payload: { receiveType: "postData" },
  };
}

export function getDeviceID(driverId) {
  return {
    types: [
      `GET_DEVICE_ID_PENDING`,
      `GET_DEVICE_ID_FULFILLED`,
      `GET_DEVICE_ID_REJECTED`,
    ],
    url: `v1/corporate-booking/deviceToken/${driverId}`,
  };
}

export function getAudit(bookingId) {
  return {
    types: [`AUDIT_GET_PENDING`, `AUDIT_GET_FULFILLED`, `AUDIT_GET_REJECTED`],
    url: `v3/bookings/audit/business_bookings/${bookingId}`,
  };
}

export function aggregatorStatusChange(data, vehicleId, vehicleMake) {
  let method = "PATCH";
  let url = `v1/corporate-booking/driver/bookings/${data.id}/6`;
  delete data.id;
  return {
    types: [
      `AGGREGATOR_STATUS_CHANGE_PENDING`,
      `AGGREGATOR_STATUS_CHANGE_FULFILLED`,
      `AGGREGATOR_STATUS_CHANGE_REJECTED`,
    ],
    method,
    url,
    data,
  };
}

export function aggregatorStatusArrived(data, vehicleId, vehicleMake) {
  let method = "PATCH";
  let url = `v1/corporate-booking/driver/bookings/${data.id}/7`;
  delete data.id;
  return {
    types: [
      `AGGREGATOR_STATUS_CHANGE_PENDING`,
      `AGGREGATOR_STATUS_CHANGE_FULFILLED`,
      `AGGREGATOR_STATUS_CHANGE_REJECTED`,
    ],
    method,
    url,
    data,
  };
}

export function aggregatorDetach(data) {
  let method = "PATCH";
  let url = `v3/bookings/driver/detach`;
  delete data.id;
  return {
    types: [
      `AGGREGATOR_DETACH_PENDING`,
      `AGGREGATOR_DETACH_FULFILLED`,
      `AGGREGATOR_DETACH_REJECTED`,
    ],
    method,
    url,
    data,
  };
}

export function aggregatorStatusOntrip(data, vehicleId, vehicleMake) {
  let method = "PATCH";
  let url = `v1/corporate-booking/driver/bookings/${data.id}/9`;
  delete data.id;
  return {
    types: [
      `AGGREGATOR_STATUS_CHANGE_PENDING`,
      `AGGREGATOR_STATUS_CHANGE_FULFILLED`,
      `AGGREGATOR_STATUS_CHANGE_REJECTED`,
    ],
    method,
    url,
    data,
  };
}

export function aggregatorStatusCompleted(data, vehicleId, vehicleMake) {
  let method = "PATCH";
  let url = `v1/corporate-booking/driver/bookings/${data.id}/10`;
  delete data.id;
  return {
    types: [
      `AGGREGATOR_STATUS_CHANGE_PENDING`,
      `AGGREGATOR_STATUS_CHANGE_FULFILLED`,
      `AGGREGATOR_STATUS_CHANGE_REJECTED`,
    ],
    method,
    url,
    data,
  };
}

export function aggregatorStatusNoShow(data, vehicleId, vehicleMake) {
  let method = "PATCH";
  let url = `v1/corporate-booking/driver/bookings/${data.id}/17`;
  delete data.id;
  return {
    types: [
      `AGGREGATOR_STATUS_CHANGE_PENDING`,
      `AGGREGATOR_STATUS_CHANGE_FULFILLED`,
      `AGGREGATOR_STATUS_CHANGE_REJECTED`,
    ],
    method,
    url,
    data,
  };
}

export function updateStatus(id) {
  let method = "PATCH";
  let url = `v1/corporate-booking/bookings/${id}/15`;
  return {
    types: [
      `UPDATE_STATUS_PENDING`,
      `UPDATE_STATUS_FULFILLED`,
      `UPDATE_STATUS_REJECTED`,
    ],
    method,
    url,
    // payload: { receiveType: "postData" },
  };
}

export function getEnquiryDetails(id) {
  return {
    types: [
      `GET_ENQUIRY_DETAILS_PENDING`,
      `GET_ENQUIRY_DETAILS_FULFILLED`,
      `GET_ENQUIRY_DETAILS_REJECTED`,
    ],
    method: "GET",
    url: `v1/corporate-booking/third-party/booking-detail/${id}`,
  };
}

export function broadcastAssign(data) {
  let method = "POST";
  let url = `v3/cp/bookings/broadcast/assign`;
  delete data.id;
  return {
    types: [
      `BROADCAST_ASSIGN_PENDING`,
      `BROADCAST_ASSIGN_FULFILLED`,
      `BROADCAST_ASSIGN_REJECTED`,
    ],
    method,
    url,
    data,
    payload: { receiveType: "postData" },
    service: "trnzOpenApi",
  };
}

export function broadcastReAssign(data) {
  let method = "POST";
  let url = `v3/cp/bookings/broadcast/reassign`;
  delete data.id;
  return {
    types: [
      `BROADCAST_RE_ASSIGN_PENDING`,
      `BROADCAST_RE_ASSIGN_FULFILLED`,
      `BROADCAST_RE_ASSIGN_REJECTED`,
    ],
    method,
    url,
    data,
    payload: { receiveType: "postData" },
    service: "trnzOpenApi",
  };
}

export function revokeAssign(id) {
  return {
    types: [
      `REVOKE_ASSIGN_PENDING`,
      `REVOKE_ASSIGN_FULFILLED`,
      `REVOKE_ASSIGN_REJECTED`,
    ],
    url: `v3/cp/bookings/revoke/${id}`,
    method: "DELETE",
    service: "trnzOpenApi",
  };
}

export function wavescabAssign(id, data) {
  // data: optional body — { force: true } retries after the admin confirms
  // the "already assigned to Waves/Refex" prompt.
  return {
    types: [
      `WAVESCAB_ASSIGN_PENDING`,
      `WAVESCAB_ASSIGN_FULFILLED`,
      `WAVESCAB_ASSIGN_REJECTED`,
    ],
    url: `trip/v1/auth/admin/supplier/wavescab/assign/${id}`,
    method: "POST",
    ...(data ? { data } : {}),
    service: "trnzOpenApi",
  };
}

export function refexSearch(id) {
  return {
    types: [
      `REFEX_SEARCH_PENDING`,
      `REFEX_SEARCH_FULFILLED`,
      `REFEX_SEARCH_REJECTED`,
    ],
    url: `trip/v1/auth/admin/supplier/refex/search/${id}`,
    method: "POST",
    service: "trnzOpenApi",
  };
}

export function refexBlock(id, data) {
  return {
    types: [
      `REFEX_BLOCK_PENDING`,
      `REFEX_BLOCK_FULFILLED`,
      `REFEX_BLOCK_REJECTED`,
    ],
    url: `trip/v1/auth/admin/supplier/refex/block/${id}`,
    method: "POST",
    data,
    service: "trnzOpenApi",
  };
}

export function refexConfirm(id) {
  return {
    types: [
      `REFEX_CONFIRM_PENDING`,
      `REFEX_CONFIRM_FULFILLED`,
      `REFEX_CONFIRM_REJECTED`,
    ],
    url: `trip/v1/auth/admin/supplier/refex/confirm/${id}`,
    method: "POST",
    service: "trnzOpenApi",
  };
}

export function portalSupplierSearch(id) {
  return {
    types: [
      `PORTAL_SUPPLIER_SEARCH_PENDING`,
      `PORTAL_SUPPLIER_SEARCH_FULFILLED`,
      `PORTAL_SUPPLIER_SEARCH_REJECTED`,
    ],
    url: `trip/v1/auth/admin/supplier/portal/search/${id}`,
    method: "POST",
    service: "trnzOpenApi",
  };
}

export function portalSupplierBlock(id, data) {
  return {
    types: [
      `PORTAL_SUPPLIER_BLOCK_PENDING`,
      `PORTAL_SUPPLIER_BLOCK_FULFILLED`,
      `PORTAL_SUPPLIER_BLOCK_REJECTED`,
    ],
    url: `trip/v1/auth/admin/supplier/portal/block/${id}`,
    method: "POST",
    data,
    service: "trnzOpenApi",
  };
}

export function portalSupplierConfirm(id) {
  return {
    types: [
      `PORTAL_SUPPLIER_CONFIRM_PENDING`,
      `PORTAL_SUPPLIER_CONFIRM_FULFILLED`,
      `PORTAL_SUPPLIER_CONFIRM_REJECTED`,
    ],
    url: `trip/v1/auth/admin/supplier/portal/confirm/${id}`,
    method: "POST",
    service: "trnzOpenApi",
  };
}

export function confirmDriver(data) {
  let method = "PATCH";
  let url = `v3/cp/bookings/broadcast/driver_confirm/${data.id}`;
  delete data.id;
  return {
    types: [
      `CONFIRM_DRIVER_PENDING`,
      `CONFIRM_DRIVER_FULFILLED`,
      `CONFIRM_DRIVER_REJECTED`,
    ],
    method,
    url,
    data,
    payload: { receiveType: "postData" },
    service: "trnzOpenApi",
  };
}

export function whatsappAssign(bookingId) {
  return {
    types: [
      `GET_WHATSAPP_ASSIGN_PENDING`,
      `GET_WHATSAPP_ASSIGN_FULFILLED`,
      `GET_WHATSAPP_ASSIGN_REJECTED`,
    ],
    method: "GET",
    url: `v3/cp/bookings/assign/driver_by_whatsapp/${bookingId}`,
    service: "trnzOpenApi",
  };
}

export function getSellerEnquiryDetails(id, messageId) {
  return {
    types: [
      `GET_SELLER_ENQUIRY_DETAILS_PENDING`,
      `GET_SELLER_ENQUIRY_DETAILS_FULFILLED`,
      `GET_SELLER_ENQUIRY_DETAILS_REJECTED`,
    ],
    method: "GET",
    url: `v1/auth/seller/enquiry/detail?transactionId=${id}&messageId=${messageId}&`,
    service: "partnerApi",
  };
}

export function getBuyerEnquiryDetails(bookingId) {
  return {
    types: [
      `GET_BUYER_ENQUIRY_DETAILS_PENDING`,
      `GET_BUYER_ENQUIRY_DETAILS_FULFILLED`,
      `GET_BUYER_ENQUIRY_DETAILS_REJECTED`,
    ],
    method: "GET",
    url: `v1/auth/seller/bookings/admin/${bookingId}`,
    service: "partnerApi",
  };
}

export function ondcDriverAssign(data, vehicleId, vehicleMake) {
  let method = "PATCH";
  let url = "v1/auth/seller/personal_transit/driver_assign";
  return {
    types: [
      `ONDC_DRIVER_ASSIGN_PENDING`,
      `ONDC_DRIVER_ASSIGN_FULFILLED`,
      `ONDC_DRIVER_ASSIGN_REJECTED`,
    ],
    method,
    url,
    data,
    payload: { receiveType: "postData" },
    service: "partnerApi",
  };
}

export function ondcCancelTrip(data) {
  let method = "PATCH";
  let url = "v1/auth/seller/personal_transit/cancel_booking";
  return {
    types: [
      `ONDC_CANCEL_TRIP_PENDING`,
      `ONDC_CANCEL_TRIP_FULFILLED`,
      `ONDC_CANCEL_TRIP_REJECTED`,
    ],
    method,
    url,
    data,
    payload: { receiveType: "postData" },
    service: "partnerApi",
  };
}

export function ondcCompleteTrip(data) {
  let method = "PATCH";
  let url = "v1/auth/seller/personal_transit/change_status";

  return {
    types: [
      `ONDC_COMPLETE_TRIP_PENDING`,
      `ONDC_COMPLETE_TRIP_FULFILLED`,
      `ONDC_COMPLETE_TRIP_REJECTED`,
    ],
    method,
    url,
    data,
    payload: { receiveType: "postData" },
    service: "partnerApi",
  };
}

export function getDistance(data) {
  const { origins, destinations } = data;

  return {
    types: [
      `GET_DISTANCE_MATRIX_PENDING`,
      `GET_DISTANCE_MATRIX_FULFILLED`,
      `GET_DISTANCE_MATRIX_REJECTED`,
    ],
    url: `maps/v1/unauth/distance_matrix?origins=${origins}&destinations=${destinations}&`,
    service: "trnzOpenApi",
  };
}

export function getSlaAudit(id) {
  return {
    types: [
      `SLA_AUDIT_GET_PENDING`,
      `SLA_AUDIT_GET_FULFILLED`,
      `SLA_AUDIT_GET_REJECTED`,
    ],
    method: "GET",
    url: `trip/v1/auth/sla/audit/${id}`,
    service: "trnzOpenApi",
  };
}

export function getDriverLocations(id) {
  return {
    types: [
      `GET_DRIVER_LOCATIONS_PENDING`,
      `GET_DRIVER_LOCATIONS_FULFILLED`,
      `GET_DRIVER_LOCATIONS_REJECTED`,
    ],
    method: "GET",
    url: `account/v1/auth/driver/location/${id}`,
    service: "trnzOpenApi",
  };
}
